export function compareVersion(version1: string, version2: string): number {
  const version1Arr = version1.split(".")
  const version2Arr = version2.split(".")
  const minLength = Math.min(version1Arr.length, version2Arr.length)
  for (let i = 0; i < minLength; i++) {
    const version1Num = Number(version1Arr[i])
    const version2Num = Number(version2Arr[i])
    if (version1Num < version2Num) return 1
    if (version1Num > version2Num) return -1
  }
  return 0
}
